module.exports = __webpack_public_path__ + "img/20210703_161524.64a9475f.jpg";